import NextImage from "next/image";
export { NextImage };
